'use client';

import { createContext, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export const ToastContext = createContext({
  showToast: () => { },
});

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);

  const handleClose = useCallback((event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setToast((prev) => {
      if (!prev) return prev;
      return { ...prev, open: false };
    });
  }, []);

  const showToast = useCallback(({ message, severity = 'info', duration = 3000, debug }) => {
    if (!message) return;

    if (debug && process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.info('[Toast debug]', message, debug);
    }

    setToast({
      key: Date.now(),
      message,
      severity,
      duration: duration || 3000,
      open: true,
    });
  }, []);

  const contextValue = useMemo(() => ({ showToast }), [showToast]);

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <Snackbar
        key={toast?.key}
        open={toast?.open || false}
        autoHideDuration={toast?.duration}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleClose} severity={toast?.severity || 'info'} variant="filled" sx={{ width: '100%' }}>
          {toast?.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
}

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};


